import React from "react";
import { render } from "react-dom";
import { HashRouter, Routes, Route } from "react-router-dom";
import data from "../data/copy.json";
import Landing from "./components/Landing";
import Article from "./components/Article";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

window.onload = () => {
  const node = document.getElementById("app");
  render(<App />, node);
};

const App = () => (
  <HashRouter basename="/">
    <ScrollToTop>
      <Routes>
        {data.articles.map((d) => (
          <Route
            key={d.slug}
            path={`/${d.slug}`}
            element={
              <>
                <Article article={d} />
                <Footer />
              </>
            }
          />
        ))}
        <Route
          path="/"
          element={
            <>
              <Landing data={data} />
              <Footer />
            </>
          }
        />
      </Routes>
    </ScrollToTop>
  </HashRouter>
);

export default App;
